export default "__VITE_ASSET__BwpOxr63__"